import React from 'react';
import { FaHome, FaUsers, FaUserTie, FaBuilding, FaCar, FaCreditCard, FaShieldAlt, FaChartLine, FaServer, FaHeadset, FaFileAlt, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { auth } from '../../firebase';

const menuItems = [
  { id: 'live', label: 'Live Operations', icon: FaHome },
  { id: 'riders', label: 'Riders', icon: FaUsers },
  { id: 'drivers', label: 'Drivers', icon: FaUserTie },
  { id: 'owners', label: 'Fleet Owners', icon: FaBuilding },
  { id: 'rides', label: 'Rides', icon: FaCar },
  { id: 'payments', label: 'Payments', icon: FaCreditCard },
  { id: 'fraud', label: 'Fraud & Safety', icon: FaShieldAlt },
  { id: 'analytics', label: 'Analytics', icon: FaChartLine },
  { id: 'monitoring', label: 'System Monitoring', icon: FaServer },
  { id: 'support', label: 'Support', icon: FaHeadset },
  { id: 'applications', label: 'Driver Apps', icon: FaFileAlt },
  { id: 'settings', label: 'Settings', icon: FaCog },
];

export const Sidebar = ({ activeTab, setActiveTab }) => {
  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await auth.signOut();
    }
  };

  return (
    <div className="w-64 bg-gray-900 border-r border-gray-800 flex flex-col shadow-xl">
      <div className="p-5 border-b border-gray-800">
        <h1 className="text-2xl font-bold text-limani-primary">Limani</h1>
        <p className="text-xs text-gray-500 mt-1">Operations</p>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {menuItems.map(item => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
              activeTab === item.id 
                ? 'bg-limani-primary text-white shadow-md' 
                : 'text-gray-400 hover:bg-gray-800 hover:text-white'
            }`}
          >
            <item.icon size={18} />
            <span className="text-sm font-medium">{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="p-4 border-t border-gray-800">
        <button onClick={handleLogout} className="flex items-center space-x-3 text-gray-400 hover:text-white w-full px-3 py-2 rounded-lg transition">
          <FaSignOutAlt size={18} />
          <span className="text-sm font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};
